<template>
  <span
    class="ne-fa-icon"
    :class="{ 'is-brand': isBrand }"
    :style="mergedStyle"
    :title="title || icon || null"
    aria-hidden="true"
  >{{ iconChar }}</span>
</template>

<script>
import './Styles/FaIcon.scss'
import FontAwesomeIconsObject from './FontAwesomeIconsObject'

export default {
  name: 'FaIcon',
  props: {
    icon: { type: String, default: '' },
    title: { type: String, default: '' },
    iconStyle: { type: [Object, String], default: null }
  },
  computed: {
    isBrand() {
      return (this.icon || '').split(' ')[0] === 'fab'
    },
    iconChar() {
      const hex = FontAwesomeIconsObject[this.icon]
      if (!hex) return ''
      const codePoint = parseInt(hex, 16)
      if (Number.isNaN(codePoint)) return ''
      return String.fromCodePoint(codePoint)
    },
    mergedStyle() {
      return this.iconStyle || null
    }
  }
}
</script>
